import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as fromGroups from '../../reducers/groups.reducer';
import * as fromRoot from '@app/reducers';
import { Group } from '@app/shared/models/group';
import { Role } from '@app/shared/models/role';
import { Team } from '@app/shared/models/team';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { GroupsActions } from '../../actions';

@Component({
  selector: 'app-modal-attach-role',
  templateUrl: './modal-attach-role.component.html',
  styleUrls: ['./modal-attach-role.component.scss']
})
export class ModalAttachRoleComponent implements OnDestroy {

  group: Group;
  teams: Team[];
  teamId: string;
  attributableRoles: Role[];

  attachRoleSuccess$: Observable<boolean>;
  attachRolePending$: Observable<boolean>;
  attachRoleError$: Observable<any>;

  subscriptions: Subscription[] = [];
  attachRoleForm: FormGroup;
  parsedTeams: Team[];
  selectedTeam: Team;
  selectedRole: Role;
  selectionTeamEnabled = true;
  submitted = false;

  constructor(private store$: Store<fromRoot.State & fromGroups.State>, private fb: FormBuilder, public ref: DialogRef) {
    this.group = this.ref.data.group;
    this.teamId = this.ref.data.teamId;
    this.attributableRoles = this.ref.data.attributableRoles;
    this.attachRoleSuccess$ = this.store$.select(fromGroups.getAttachRoleToGroupSuccess);
    this.attachRolePending$ = this.store$.select(fromGroups.getAttachRoleToGroupPending);
    this.attachRoleError$ = this.store$.select(fromGroups.getAttachRoleToGroupError);
    this.initGroupCreationForm();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  get f() { return this.attachRoleForm.controls; }

  initGroupCreationForm() {
    this.attachRoleForm = this.fb.group({
      role: ['', Validators.required],
    });
  }

  attachRole(role: any) {
    this.store$.dispatch(GroupsActions.AttachRoleToGroup({ teamId: this.teamId, groupId: this.group.id, role }));
    this.subscriptions.push(this.attachRoleSuccess$.subscribe(res => {
      if (res) {
        this.store$.dispatch(GroupsActions.LoadGroupRoles({ teamId: this.teamId, id: this.group.id }));
        this.close();
      }
    }));
  }

  close() {
    this.submitted = false;
    this.selectedTeam = null;
    this.selectedRole = null;
    this.attachRoleForm.reset();
    this.ref.close();
  }

  onSubmit() {
    this.submitted = true;
    if (this.attachRoleForm.valid) {
      this.attachRole(this.attachRoleForm.value.role);
    }
  }
}
